import React from 'react';
import { Container } from 'react-bootstrap';
import { Checkbox, CircularProgress, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, OutlinedInput, Paper, styled, TextareaAutosize, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import SelectBlackButton from '../../components/common/SelectButton';
import AffiliatesTerms from '../../components/affiliates/AffiliatesTerms';
import SuccessMessage from '../../components/common/SuccessMessage';
import AmbassadorTerms from '../../components/affiliates/AmbassadorTerms';

const sendApplication = async (payload) => {
  const url = `${process.env.API_URL}/affiliate/signup/`;
  const req = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return req;
};

const SelectPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 5,
  borderColor: '#000',
  border: 0,
  padding: 50,
  margin: 70,
  [theme.breakpoints.down('md')]: {
    padding: 5,
    margin: 0,
  },
}));

export default function AffiliatesPage(props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [openAffiliates, setOpenAffiliates] = React.useState(false);
  const [openAmbassador, setOpenAmbassador] = React.useState(false);
  const [successShow, setSuccessShow] = React.useState(false);
  const { title } = props;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {},
  });
  console.log(errors);
  const onSubmit = async (data) => {
    let { website } = data;
    // added website http and https
    if (website && !website.includes('http://') && !website.includes('https://')) {
      website = `https://${website}`;
    }
    try {
      setIsLoading(true);
      const req = await sendApplication({ ...data, type: title, website });
      const res = await req.json();
      if (req.status === 400) {
        if (_.isObject(res)) {
          _.forOwn(res, (val, key) => {
            setError(key, { type: 'custom', message: val[0] });
            console.log(val[0]);
          });
        }
      } else {
        setSuccessShow(true);
      }
      console.log(res);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const termsRender = () => {
    if (title === 'affiliate') {
      return (
        <>
          <FormControlLabel control={<Checkbox {...register('terms', { required: true })} />} label="I agree to the Select Affiliate Partner Terms." />
          <Typography variant="caption" display="block" gutterBottom sx={{ alignContent: 'right', cursor: 'pointer' }} onClick={() => setOpenAffiliates(true)}>
            Show Select Affiliate Partner Terms
          </Typography>
          {errors.terms && <FormHelperText error>{errors.terms.message}</FormHelperText>}
          <AffiliatesTerms handleClose={() => setOpenAffiliates(false)} open={openAffiliates} />
        </>
      );
    }
    return (
      <>
        <FormControlLabel control={<Checkbox {...register('terms', { required: true })} />} label="I agree to the Select Ambassador Partner Terms." />
        <Typography variant="caption" display="block" gutterBottom sx={{ alignContent: 'right', cursor: 'pointer' }} onClick={() => setOpenAmbassador(true)}>
          Show Select Ambassador Partner Terms
        </Typography>
        {errors.terms && <FormHelperText error>{errors.terms.message}</FormHelperText>}
        <AmbassadorTerms handleClose={() => setOpenAmbassador(false)} open={openAmbassador} />
      </>
    );
  };

  const compannyRender = () => {
    if (title === 'affiliate') {
      return (
        <Grid item xs={12} md={6}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Company</InputLabel>
            <OutlinedInput
              {...register('company', {
                required: 'Company is required',
                maxLength: {
                  value: 50,
                  message: 'Maximum length is 50',
                },
                minLength: {
                  value: 2,
                  message: 'Minimum length is 2',
                },
              })}
              label="Company"
            />
            {errors.company && <FormHelperText error>{errors.company.message}</FormHelperText>}
          </FormControl>
        </Grid>
      );
    }
    return (
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Company (Optional) </InputLabel>
          <OutlinedInput {...register('company')} label="Company (Optional)" />
          {errors.company && <FormHelperText error>{errors.company.message}</FormHelperText>}
        </FormControl>
      </Grid>
    );
  };

  return (
    <>
      <div className="bg-white mt-2">
        <Container fluid="lg" className="mt-5 px-md-10 px-sm-2 bg-white py-1">
          <form onSubmit={handleSubmit(onSubmit)}>
            <SelectPaper elevation={3}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ textAlign: 'center' }}>
                    {title === 'affiliate' ? 'Affiliate' : 'Ambassador'} Partner Application
                  </Typography>
                  <Typography gutterBottom sx={{ borderBottom: 1, mb: 2, textAlign: 'center', mx: 5 }}>
                    Join the Select family and share the #SelectLife. If approved, you'll receive a membership and commission for member referrals.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ borderBottom: 1 }}>
                    Account Details
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Email</InputLabel>
                    <OutlinedInput
                      {...register('email', {
                        required: `Email is required`,
                        type: 'email',
                      })}
                      type="email"
                      label="Email"
                    />
                    {errors.email && <FormHelperText error>{errors.email.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                {compannyRender()}
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Address Line 1</InputLabel>
                    <OutlinedInput
                      {...register('address1', {
                        required: 'Address Line 1 is required',
                        maxLength: {
                          value: 50,
                          message: 'Maximum length is 50',
                        },
                        minLength: {
                          value: 5,
                          message: 'Minimum length is 5',
                        },
                      })}
                      label="Address Line 1"
                    />

                    {errors.address1 && <FormHelperText error>{errors.address1.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Address Line 2 (Optional)</InputLabel>
                    <OutlinedInput {...register('address2')} label="Address Line 2 (Optional)" />
                    {errors.address2 && <FormHelperText error>{errors.address2.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Zip Code</InputLabel>
                    <OutlinedInput {...register('zipcode', { required: 'Zipcode is required' })} label="Zip Code" />
                    {errors.zipcode && <FormHelperText error>{errors.zipcode.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>City</InputLabel>
                    <OutlinedInput {...register('city', { required: 'City is required' })} label="City" />
                    {errors.city && <FormHelperText error>{errors.city.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>State</InputLabel>
                    <OutlinedInput {...register('state', { required: 'State is required' })} label="State" />
                    {errors.state && <FormHelperText error>{errors.state.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ borderBottom: 1, mt: 3 }}>
                    User Details
                  </Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Title (Optional)</InputLabel>
                    <OutlinedInput {...register('title')} label="Title (Optional)" />
                    {errors.title && <FormHelperText error>{errors.title.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={5}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>First Name</InputLabel>
                    <OutlinedInput {...register('first_name', { required: 'First Name is required' })} label="First Name" />
                    {errors.first_name && <FormHelperText error>{errors.first_name.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={5}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Last Name</InputLabel>
                    <OutlinedInput {...register('last_name', { required: 'Last Name is required' })} label="Last Name" />
                    {errors.last_name && <FormHelperText error>{errors.last_name.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
                    Additional Questions
                  </Typography>
                  <Typography variant="body1" gutterBottom sx={{ borderBottom: 1 }}>
                    These fields help us understand how and where you would share Select. Please fill out any that are relevant to your marketing efforts for Select.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Website (Optional)</InputLabel>
                    <OutlinedInput {...register('website')} label="Website (Optional)" />
                    {errors.website && <FormHelperText error>{errors.website.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Instagram (Optional)</InputLabel>
                    <OutlinedInput {...register('instagram')} label="Instagram (Optional)" />
                    {errors.instagram && <FormHelperText error>{errors.instagram.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>TikTok (Optional)</InputLabel>
                    <OutlinedInput {...register('tiktok')} label="TikTok (Optional)" />
                    {errors.tiktok && <FormHelperText error>{errors.tiktok.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Facebook (Optional)</InputLabel>
                    <OutlinedInput {...register('facebook')} label="Facebook (Optional)" />
                    {errors.facebook && <FormHelperText error>{errors.facebook.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Twitter (Optional)</InputLabel>
                    <OutlinedInput {...register('twitter')} label="Twitter (Optional)" />
                    {errors.twitter && <FormHelperText error>{errors.twitter.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Youtube (Optional)</InputLabel>
                    <OutlinedInput {...register('youtube')} label="Youtube (Optional)" />
                    {errors.youtube && <FormHelperText error>{errors.youtube.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Linkedin (Optional)</InputLabel>
                    <OutlinedInput {...register('linkedin')} label="Linkedin (Optional)" />
                    {errors.linkedin && <FormHelperText error>{errors.linkedin.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>If referred (Optional)</InputLabel>
                    <OutlinedInput {...register('referral')} label="Referral (Optional)" />
                    {errors.referral && <FormHelperText error>{errors.referral.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <TextareaAutosize minRows={3} {...register('join')} placeholder="Why would you like to join? (Optional)" />
                    {errors.join && <FormHelperText error>{errors.join.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <TextareaAutosize
                      variant="outlined"
                      minRows={3}
                      {...register('plan', { required: 'This field is required' })}
                      placeholder={title === 'affiliate' ? 'How do you plan to market Select and invite your community?' : 'How will you market and/or create content for Select?'}
                    />
                    {errors.plan && <FormHelperText error>{errors.plan.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  {termsRender()}
                  <SuccessMessage
                    open={successShow}
                    handleClose={() => setSuccessShow(false)}
                    title="Thank you for your application!"
                    message="Our team will review your information within five business days. We'll reach out with next steps if it's a good fit or if we have any questions."
                  />
                </Grid>
                <Grid item xs={12} sx={{ alignContent: 'center', textAlign: 'center' }}>
                  {isLoading && <CircularProgress size={20} sx={{ marginRight: 1, alignContent: 'center' }} />}
                  {!isLoading && <SelectBlackButton label="Submit" type="submit" disabled={!watch('terms')} />}
                  {Object.keys(errors).length > 0 && <FormHelperText error>There are some errors in the form</FormHelperText>}
                </Grid>
              </Grid>
            </SelectPaper>
          </form>
        </Container>
      </div>
    </>
  );
}
